import React from "react";
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const Inbox = () => {
  return <div><ComingSoon /></div>;
};

export default Inbox;
